"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var React = require("react");
var Types = require("types");
var react_router_dom_1 = require("react-router-dom");
var recompose_1 = require("recompose");
var react_redux_1 = require("react-redux");
var sok_ui_1 = require("@caddigital/sok-ui");
var ShortcutOverlay_1 = require("./ShortcutOverlay");
var FilesActions = require("@caddigital/sok-reducers/lib/actions/files");
var AuthActions = require("@caddigital/sok-reducers/lib/actions/auth/zendesk");
var ProjectHomeActions = require("@caddigital/sok-reducers/lib/actions/project/home");
var subprojectActions = require("@caddigital/sok-reducers/lib/actions/subproject/list");
var toastActions = require("@caddigital/sok-reducers/lib/actions/toast");
var projectActions = require("@caddigital/sok-reducers/lib/actions/project");
var Greeting_1 = require("components/Greeting");
var Icon_1 = require("components/Icon");
var translate_1 = require("utils/translate");
var GenericErrorMessage_1 = require("components/GenericErrorMessage");
var GenericInviteModal_1 = require("components/modals/GenericInviteModal");
var acl = require("@caddigital/sok-reducers/lib/utils/acl");
var userGroups_1 = require("utils/userGroups");
require("./index.scss");
var Elements_1 = require("components/DashboardElements/Elements");
var ListContainer_1 = require("views/SubprojectsView/ListContainer");
function filestabEnabled(perm) {
    return (perm & (acl.PROJECT_USER_GRANT & ~acl.FEATURE_MASK) &&
        (perm & acl.FEATURE_MASK
            ? (perm & acl.FILESTAB_PERM) === acl.FILESTAB_PERM
            : 0));
}
var getProjectStatus = function (projectStatus) {
    return (0, translation_1.getLocalization)(projectStatus
        ? "projectStatus/".concat(projectStatus.name)
        : 'projectStatus/active');
};
var getProjectType = function (projectType) {
    return (0, translation_1.getLocalization)(projectType ? "projectType/".concat(projectType.name) : 'projectType/active');
};
function getUserGroups(perm, categories) {
    var accessibleCategories = (0, userGroups_1.getAccessibleCategories)(perm, categories);
    return accessibleCategories.reduce(function (res, _a) {
        var category = _a.category, groups = _a.groups;
        res.push(__assign(__assign({}, category), { disabled: category.type === 'CategoryUserGroup' ||
                category.type === 'SokoBidCategoryUserGroup' ||
                category.type === 'WorksiteDiaryUserGroup' ||
                category.type === 'TRMVRUserGroup' ||
                category.type === 'LightAdminCategoryUserGroup' }));
        groups.forEach(function (g) {
            g.name = (0, userGroups_1.getLocalizedUserGroupName)(g.name);
            return res.push(g);
        });
        return res;
    }, []);
}
function getGroups(perm, list) {
    var userGroups = getUserGroups(perm, list.categories);
    var placeHolder = [
        {
            id: -2,
            name: (0, translation_1.getLocalization)('userfront/project/teamMembers/inviteToProject/selectGroup'),
            type: 'NormalUserGroup',
            uuid: '-',
            disabled: false
        }
    ];
    return placeHolder.concat(userGroups);
}
var mapStateToProps = function (state, ownProps) {
    var selectedLanguage = (0, translate_1.getLanguage)();
    var perm = ownProps.currentProject.perm & ~acl.FEATURE_MASK;
    var isGranoOrProjectAdmin = !!(perm & acl.PROJECT_ADMIN_GRANT) ||
        state.auth.current.user
            .map(function (_a) {
            var level = _a.level;
            return level === 'SuperAdminUserGroup' ||
                level === 'SalesmanUserGroup' ||
                level === 'PremiumAdminUserGroup' ||
                false;
        })
            .getOrElse(false);
    var isGranoAdmin = state.auth.current.user
        .map(function (_a) {
        var level = _a.level;
        return level === 'SuperAdminUserGroup' ||
            level === 'SalesmanUserGroup' ||
            level === 'PremiumAdminUserGroup' ||
            false;
    })
        .getOrElse(false);
    return {
        projects: state.projects.projects,
        home: state.project.currentProject,
        cover: state.project.currentProject.cover,
        selectedFolders: state.files.selectedFolders,
        sortByOptions: state.files.sortByOptions,
        filesStatus: state.files.data.status,
        zToken: state.auth.zendesk.token,
        selectedLanguage: selectedLanguage,
        features: state.features,
        isGranoOrProjectAdmin: isGranoOrProjectAdmin,
        isGranoAdmin: isGranoAdmin,
        list: state.project.currentProject.list,
        shortcutStatus: state.project.currentProject.shortcutStatus,
        dashboard: state.project.dashboard,
        subprojects: state.subproject.list,
        userFeatures: state.auth.current.features
    };
};
/**
 * Map actions for connect
 * @param {Object} actions - actions
 * @param {Function} dispatch - Function to dispatch the actions
 * @returns {Object}
 */
var mapDispatchToProps = function (dispatch) { return ({
    fetchProjectGroupsRequest: function (id) {
        return dispatch(ProjectHomeActions.fetchProjectGroupsRequest(id));
    },
    uploadProjectCover: function (projectId, file) {
        return dispatch(ProjectHomeActions.uploadProjectCoverRequest(projectId, file));
    },
    removeProjectCover: function (projectId) {
        dispatch(ProjectHomeActions.removeProjectCoverRequest(projectId));
    },
    fetchShortcuts: function (projectId) {
        return dispatch(ProjectHomeActions.fetchShortcutsRequest(projectId));
    },
    toggleFolderTree: function (folder) {
        if (folder !== undefined) {
            dispatch(ProjectHomeActions.FolderTreeActions.copyFilesToggleOverlay(Types.Reducer.MOVE));
            dispatch(ProjectHomeActions.FolderTreeActions.setCopyOrMoveRootExpanded(true));
            dispatch(ProjectHomeActions.FolderTreeActions.fetchTree(folder));
        }
        else {
            dispatch(ProjectHomeActions.FolderTreeActions.copyFilesReset());
            dispatch(ProjectHomeActions.FolderTreeActions.copyFilesToggleOverlay(Types.Reducer.CLOSED));
        }
    },
    getContent: function (parent) {
        return dispatch(ProjectHomeActions.FolderTreeActions.fetchTree(parent));
    },
    deleteShortcut: function (projectId, folderId) { return function () {
        dispatch(ProjectHomeActions.deleteShortcutRequest(projectId, folderId));
    }; },
    resetSelectedFolders: function () { return dispatch(FilesActions.resetSelectedFolders()); },
    zendeskToken: function () { return dispatch(AuthActions.createZendeskTokenRequest()); },
    clearToken: function () { return dispatch(AuthActions.resetZendeskToken()); },
    clear: function () { return (dispatch(ProjectHomeActions.clear()),
        dispatch(projectActions.DashboardActions.clear()),
        dispatch(subprojectActions.clear())); },
    toggleInviteModal: function () {
        return dispatch(ProjectHomeActions.UsergroupInvite.inviteToggleModal());
    },
    selectItem: function (uuid, itemId) {
        return dispatch(ProjectHomeActions.UsergroupInvite.inviteSelectItem(uuid, itemId));
    },
    addNewRow: function (item) {
        return dispatch(ProjectHomeActions.UsergroupInvite.addRow(item.uuid, item.group, item.emails, item.language));
    },
    removeRow: function (uuid) {
        return dispatch(ProjectHomeActions.UsergroupInvite.removeRow(uuid));
    },
    updateEmails: function (uuid) { return function (email) {
        return dispatch(ProjectHomeActions.UsergroupInvite.updateEmails(uuid, email));
    }; },
    updateLanguage: function (uuid, language) {
        return dispatch(ProjectHomeActions.UsergroupInvite.UpdateLanguage(uuid, language));
    },
    uploadProjectCoverSuccess: function (cover) {
        return dispatch(ProjectHomeActions.uploadProjectCoverSuccess(cover));
    },
    sendInvitations: function (inviteRows) {
        return function () {
            return dispatch(ProjectHomeActions.UsergroupInvite.inviteRequest(inviteRows));
        };
    },
    fetchUserGroups: function (id) {
        return dispatch(ProjectHomeActions.fetchProjectGroupsRequest(id));
    },
    addNewToast: function (title, message, type) {
        return dispatch(toastActions.addNewToast(title, message, type));
    },
    fetchDashboard: function (projectId) {
        return dispatch(projectActions.DashboardActions.fetchRequest('PROJECT', projectId));
    },
    fetchSubprojects: function (project) {
        return dispatch(subprojectActions.fetchRequest(project));
    }
}); };
var zendesk = null;
var HomeView = function (props) {
    var message = (React.createElement(React.Fragment, null,
        React.createElement("li", null,
            " ", "".concat((0, translation_1.getLocalization)('invite/member/info')),
            " "),
        React.createElement("li", null,
            " ", "".concat((0, translation_1.getLocalization)('invite/member/info/second')),
            " "),
        React.createElement("li", null,
            " ", "".concat((0, translation_1.getLocalization)('invite/member/info/third')),
            " ")));
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: 'content-wrapper-content' },
            React.createElement("div", { className: 'project-home-view' },
                React.createElement("main", { className: 'content' },
                    React.createElement(sok_ui_1.BreadCrumb, null,
                        React.createElement(react_router_dom_1.Link, { to: "/".concat(props.selectedLanguage, "/projects/") +
                                props.currentProject.id }, props.currentProject.name),
                        React.createElement("span", null, (0, translation_1.getLocalization)('breadcrumb/projectname/projectHome'))),
                    React.createElement(Greeting_1.Greeting, { message: React.createElement("span", null,
                            (0, translation_1.getLocalization)('userfront/project/projectHome/message/welcomeTo'),
                            ' ',
                            React.createElement("strong", null, props.currentProject.name),
                            ' ',
                            (0, translation_1.getLocalization)('userfront/project/projectHome/message/andHaveAgreatDayAtWorkToday')) }),
                    React.createElement("div", { className: "quick-access card-box" },
                        React.createElement("h2", null,
                            React.createElement(Icon_1.Icon, { className: "fa-rocket fa-fw" }),
                            ' ',
                            (0, translation_1.getLocalization)('userfront/project/projectHome/quickAccess/')),
                        React.createElement("div", { className: "features card-box-content" },
                            React.createElement(sok_ui_1.Button, { icon: React.createElement(Icon_1.Icon, { className: "fa-book" }), color: "dark-gray", border: "red", text: (0, translation_1.getLocalization)('userfront/project/projectHome/quickAccess/buttons/tutorials'), size: "large", block: true, onClick: function () {
                                    zendesk = window.open('about:blank', 'blank');
                                    props.zendeskToken();
                                } }),
                            props.isGranoOrProjectAdmin && (React.createElement(sok_ui_1.Button, { icon: React.createElement(Icon_1.Icon, { className: "fa-user-plus" }), color: "dark-gray", border: "green", text: (0, translation_1.getLocalization)('userfront/project/projectHome/quickAccess/buttons/inviteUsers'), size: "large", block: true, onClick: function () {
                                    props.fetchUserGroups(props.currentProject.id);
                                    props.toggleInviteModal();
                                } })),
                            filestabEnabled(props.currentProject.perm) ? (React.createElement(sok_ui_1.Button, { url: "/".concat(props.selectedLanguage, "/projects/").concat(props.currentProject.id, "/files"), icon: React.createElement(Icon_1.Icon, { className: "fa-folder" }), color: "dark-gray", border: "blue", size: "large", block: true }, (0, translation_1.getLocalization)('userfront/project/projectHome/quickAccess/buttons/files'))) : undefined,
                            __EDIT_PROJECT__ &&
                                (props.currentProject.perm & acl.SUPER_ADMIN_GRANT) > 0 ? (React.createElement(sok_ui_1.Button, { url: "/".concat(props.selectedLanguage, "/admin/projects/").concat(props.currentProject.id), icon: React.createElement(Icon_1.Icon, { className: "fa-cogs" }), color: 'blue', size: 'large', block: true }, (0, translation_1.getLocalization)('admin/projectsTab/toolTips/editProject'))) : undefined)),
                    props.dashboardElements[2] &&
                        props.dashboardElements[2].map(function (x, i) { return (React.createElement(Elements_1.RenderDashboard, { key: "element-".concat(x.id, "-").concat(i), dashboard: x })); }),
                    React.createElement("div", { className: "card-box" },
                        React.createElement("h2", null,
                            React.createElement(Icon_1.Icon, { className: "fa-building fa-fw" }),
                            ' ',
                            (0, translation_1.getLocalization)('userfront/project/projectHome/projectInformation')),
                        React.createElement("div", { className: "info-box card-box-content" },
                            React.createElement("div", { className: "cover" },
                                React.createElement(sok_ui_1.CoverEditor, { image: props.cover
                                        ? "".concat(__APIBASEURL__, "api/project/").concat(props.currentProject.id, "/cover?t=").concat(props.image)
                                        : undefined, isUploading: props.home.isModifyingCover, onUpload: function (file) {
                                        return props.uploadProjectCover(props.currentProject.id, file);
                                    }, onRemove: function () {
                                        return props.removeProjectCover(props.currentProject.id);
                                    }, disabled: !props.isGranoOrProjectAdmin })),
                            React.createElement("div", { className: "meta-info" },
                                React.createElement("div", { className: 'row' },
                                    React.createElement("div", { className: 'column card' },
                                        React.createElement("span", { className: 'column-icon' },
                                            React.createElement("i", { className: 'fa fa-tag' })),
                                        React.createElement("div", { className: 'card-inner' },
                                            React.createElement("div", { className: "meta-title" }, (0, translation_1.getLocalization)('userfront/project/projectHome/projectInformation/nameTitle')),
                                            React.createElement("div", { className: "meta-content" },
                                                React.createElement("div", null, props.currentProject.name)))),
                                    React.createElement("div", { className: 'column card' },
                                        React.createElement("span", { className: 'column-icon' },
                                            React.createElement("i", { className: 'fa fa-key' })),
                                        React.createElement("div", { className: 'card-inner' },
                                            React.createElement("div", { className: "meta-title" }, (0, translation_1.getLocalization)('userfront/project/projectHome/projectInformation/OwnerTitle')),
                                            React.createElement("div", { className: "meta-content" }, props.currentProject.customerName)))),
                                React.createElement("div", { className: 'row' },
                                    React.createElement("div", { className: 'column card full-width' },
                                        React.createElement("div", { className: 'card-inner' },
                                            React.createElement(sok_ui_1.Grid.Row, null,
                                                React.createElement(sok_ui_1.Grid.Column, { small: 6 },
                                                    React.createElement("div", { className: "meta-title project-status" }, (0, translation_1.getLocalization)('userfront/project/projectHome/projectInformation/ProjectStatusTitle')),
                                                    React.createElement("div", { className: "meta-content" },
                                                        React.createElement("div", { className: 'status' }, getProjectStatus(props.currentProject.projectStatus)))),
                                                React.createElement(sok_ui_1.Grid.Column, { small: 6 },
                                                    React.createElement("div", { className: "meta-title project-type" }, (0, translation_1.getLocalization)('userfront/project/projectHome/projectInformation/ProjectTypeTitle')),
                                                    React.createElement("div", { className: "meta-content" },
                                                        React.createElement("div", { className: 'status' }, getProjectType(props.currentProject.projectType))))),
                                            React.createElement("div", { className: "meta-title project-admin" }, (0, translation_1.getLocalization)('userfront/project/projectHome/projectInformation/projectAdminsTitle')),
                                            React.createElement("div", { className: "meta-content" }, props.currentProject.projectAdmins &&
                                                props.currentProject.projectAdmins.length > 0
                                                ? props.currentProject.projectAdmins.map(function (m, i) { return (React.createElement("div", { key: "email-".concat(i), className: 'email-tag' },
                                                    React.createElement("span", null, m))); })
                                                : (0, translation_1.getLocalization)('userfront/project/projectHome/none'))))))),
                        React.createElement(GenericInviteModal_1.default, { isOpen: props.home.invite.isOpen, modalTitle: (0, translation_1.getLocalization)('invite/member'), message: message, status: props.home.invite.status, inviteRows: props.home.invite.inviteRows, items: getGroups(props.currentProject.perm || 0, props.list), toggleModal: props.toggleInviteModal, selectItem: props.selectItem, updateEmails: props.updateEmails, updateLanguage: props.updateLanguage, addNewRow: props.addNewRow, removeRow: props.removeRow, addNewToast: props.addNewToast, inviteText: (0, translation_1.getLocalization)('components/modals/genericInvitationModal/invite'), sendInvitations: props.sendInvitations(props.home.invite.inviteRows), errors: props.home.invite.errors, groupStatus: props.home.groupStatus, exportAddress: "".concat(__APIBASEURL__, "api/project/").concat(props.currentProject.id, "/members") })),
                    props.dashboardElements[3] &&
                        props.dashboardElements[3].map(function (x, i) { return (React.createElement(Elements_1.RenderDashboard, { key: "element-".concat(x.id, "-").concat(i), dashboard: x })); }),
                    props.currentProject.perm & acl.SUBPROJECT_PERM &&
                        props.subprojects.list.length > 0 ? (React.createElement("div", { className: 'card-box' },
                        React.createElement("h2", null,
                            React.createElement(Icon_1.Icon, { className: 'fa-toolbox' }),
                            ' ',
                            (0, translation_1.getLocalization)('userfront/project/projectHome/subprojects')),
                        React.createElement("div", { className: 'card-box-content subproject-container' }, props.subprojects.list.map(function (x) {
                            x.subproject.customMeta.sort(function (a, b) { return b.order - a.order; });
                            return (React.createElement("div", { className: 'subproject-card' },
                                React.createElement("div", null,
                                    React.createElement("div", { className: 'subproject-name' },
                                        React.createElement(react_router_dom_1.Link, { to: "/".concat(props.selectedLanguage, "/projects/").concat(x.project.id, "/files/").concat(x.subproject.id) }, x.subproject.name)),
                                    x.subproject.customMeta.map(function (c) { return (React.createElement("div", { className: 'subproject-meta' },
                                        (0, translation_1.getLocalization)("subprojectMeta/".concat(c.name)),
                                        ":",
                                        ' ',
                                        (0, ListContainer_1.subprojectMeta)(c))); }))));
                        })))) : undefined,
                    React.createElement("div", { className: "card-box" }, filestabEnabled(props.currentProject.perm)
                        ? [
                            React.createElement("h2", { key: 'header' },
                                React.createElement(Icon_1.Icon, { className: "fa-folder fa-fw" }),
                                ' ',
                                (0, translation_1.getLocalization)('userfront/project/projectHome/folderShortcuts')),
                            React.createElement("div", { key: 'add-shortcut', className: "card-box-content" },
                                React.createElement(sok_ui_1.Button, { color: "base-green", text: (0, translation_1.getLocalization)('userfront/project/projectHome/folderShortcuts/button/addNewFolderShortcuts'), onClick: function () {
                                        props.toggleFolderTree({
                                            id: props.currentProject.rootFolder,
                                            uuid: props.currentProject.rootFolderIdentifier,
                                            project: props.currentProject.id
                                        });
                                    } }),
                                React.createElement("div", { key: 'shortcut-list', className: "shortcuts-list" }, props.shortcutStatus === 'FETCHING' ||
                                    props.shortcutStatus === 'SAVING' ||
                                    props.shortcutStatus === 'SAVED' ? (React.createElement(sok_ui_1.LoadingSpinner, null)) : props.shortcutStatus === 'FETCHED' ? (props.home.shortcuts.map(function (folder, index) { return (React.createElement("div", { key: index, className: 'row' },
                                    React.createElement(Icon_1.Icon, { className: "fa-folder" }),
                                    React.createElement("div", null,
                                        React.createElement(react_router_dom_1.Link, { to: "/".concat(props.selectedLanguage, "/projects/") +
                                                props.currentProject.id +
                                                '/files/' +
                                                folder.id }, folder.path)),
                                    React.createElement(Icon_1.Icon, { className: "fa-times-circle", onClick: props.deleteShortcut(props.currentProject.id, folder.id) }))); })) : (React.createElement(GenericErrorMessage_1.default, { key: 'error', title: (0, translation_1.getLocalization)('generic/error') })))),
                            React.createElement(ShortcutOverlay_1.ShortcutOverlay, { key: 'sidemenu', currentProject: props.currentProject })
                        ]
                        : undefined),
                    props.dashboardElements[4] &&
                        props.dashboardElements[4].map(function (x, i) { return (React.createElement(Elements_1.RenderDashboard, { key: "element-".concat(x.id, "-").concat(i), dashboard: x })); }))))));
};
var enhance = (0, recompose_1.compose)((0, recompose_1.withState)('image', 'setImage', undefined), (0, recompose_1.withState)('dashboardElements', 'setDashboardElements', {}), (0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps), (0, recompose_1.lifecycle)({
    componentDidUpdate: function (prevProps) {
        var _this = this;
        if (this.props.selectedFolders !== prevProps.selectedFolders) {
            this.props.fetchShortcuts(this.props.currentProject.id);
        }
        // Uploaded or not uploading cover but state has been fetched
        if ((!this.props.home.isModifyingCover &&
            this.props.home.isModifyingCover !==
                prevProps.home.isModifyingCover) ||
            prevProps.home.cover !== this.props.home.cover) {
            this.props.setImage(new Date().getTime());
        }
        if (zendesk && this.props.zToken !== '') {
            var url = "https://sokopro.zendesk.com/access/jwt?jwt=".concat(this.props.zToken, "&return_to=https://sokopro.zendesk.com/");
            zendesk.location.href = url;
            zendesk.focus();
            zendesk = null;
            this.props.clearToken();
        }
        if (this.props.dashboard.boards !== prevProps.dashboard.boards) {
            var lookup = this.props.dashboard.boards.reduce(function (acc, item) {
                var list = acc[item.position] || [];
                list.push(item);
                acc[item.position] = list;
                return acc;
            }, {});
            for (var i = 2; i <= 4; i++) {
                if (Array.isArray(lookup[i])) {
                    lookup[i].sort(function (a, b) { return (a.id || 0) - (b.id || 0); });
                }
            }
            this.props.setDashboardElements(lookup);
        }
        if (this.props.home.invite.isOpen &&
            this.props.home.invite.status === 'INVITED' &&
            prevProps.home.invite.status === 'INVITING') {
            var res = this.props.home.invite.inviteRows.reduce(function (acc, x) {
                if (_this.props.subprojects.list.findIndex(function (item) {
                    var _a;
                    var meta = item.subproject.customMeta.find(function (m) { return m.identifier === 'subproject-responsible-person-meta'; });
                    if ((meta === null || meta === void 0 ? void 0 : meta.type) === 'reference') {
                        return (((_a = meta.value) === null || _a === void 0 ? void 0 : _a.id) ===
                            x.group);
                    }
                }) > -1) {
                    acc.subproject = true;
                }
                return acc;
            }, { subproject: false, admin: false });
            if (res.subproject) {
                this.props.fetchSubprojects(this.props.currentProject);
            }
        }
    },
    componentDidMount: function () {
        this.props.fetchDashboard(this.props.currentProject.id);
        if (filestabEnabled(this.props.currentProject.perm)) {
            this.props.fetchShortcuts(this.props.currentProject.id);
        }
        if (this.props.currentProject.perm & acl.SUBPROJECT_PERM) {
            this.props.fetchSubprojects(this.props.currentProject);
        }
        this.props.currentProject.cover &&
            this.props.uploadProjectCoverSuccess(this.props.currentProject.cover);
        // Got information and cover
        if (this.props.home.cover) {
            this.props.setImage(new Date().getTime());
        }
    },
    componentWillUnmount: function () {
        this.props.clear();
    }
}), recompose_1.pure);
exports.default = enhance(HomeView);
